export const FEATURE_FLAGS = {
  BILLING: 'billing',
  RUNTIME_REVIEW: 'runtime_review',
  UNIFIED_API: 'unified_api',
  QODO_20_BANNER: 'qodo_20_banner',
  REVIEW_CONFIGURATIONS: 'review_configurations',
  API_KEYS: 'api_keys',
  AZURE_INTEGRATION: 'azure_integration',
  AZURE_APP_CONSENT: 'azure_app_consent',
  FINDINGS: 'findings',
  FINDINGS_RULE_LINK: 'findings_rule_link',
  FINDINGS_EXPORT_CSV: 'findings_export_csv',
  FINDING_DISMISSAL: 'finding_dismissal',
  WIKI: 'wiki',
  GITLAB_INTEGRATION: 'gitlab_integration',
  GITLAB_MT_CLOUD_INTEGRATION: 'gitlab_mt_cloud_integration',
  GITLAB_TOKEN_AUTH: 'gitlab_token_auth',
  GITLAB_GROUP_TOKEN_AUTH: 'gitlab_group_token_auth',
  BITBUCKET_INTEGRATION: 'bitbucket_integration',
  GERRIT_INTEGRATION: 'gerrit_integration',
  GIT_REPO_MANAGEMENT: 'git_repo_management',
  GITHUB_MT_WIZARD: 'github_mt_wizard',
  GITHUB_CLOUD_WIZARD: 'github_cloud_wizard',
  GITHUB_SERVER_WIZARD: 'github_server_wizard',
  FIGMA: 'figma',
  CONTEXT_INDEXING: 'context_indexing',
  BILLING_ANALYTICS: 'billing_analytics',
  BILLING_PR_LLM_RESPONSE_COST: 'billing_pr_llm_response_cost',
  NATIVE_ANALYTICS: 'native_analytics',
  REVIEW_MODE_IN_BILLING_PORTAL: 'review_mode_in_billing_portal',
  NOTION_INTEGRATION: 'notion_integration',
  SERVICENOW_INTEGRATION: 'servicenow_integration',
  JSM_ASSETS_INTEGRATION: 'jsm_assets_integration',
  ASANA_INTEGRATION: 'asana_integration',
  SLACK_INTEGRATION: 'slack_integration',
  RESEARCH_PREVIEW: 'research_preview',
  NATIVE_SKILLS: 'native_skills',
  PRE_PR_CONFIG: 'pre_pr_config',
  TEAM_PERSONAS_CONFIG: 'team_personas_config',
  REVIEW_MD_CONFIG: 'review_md_config',
  SECURITY_AGENT_CONFIG: 'security_agent_config',
  MERGE_AUTOMATION_CONFIG: 'merge_automation_config',
  ALLOW_TEAM_ADMINS_CONFIG: 'allow_team_admins_config',
  CROSS_REPO_RELATIONSHIPS: 'cross_repo_relationships',
  CROSS_REPO_RELATIONSHIPS_TAB: 'cross_repo_relationships_tab',
  CROSS_REPO_AUTO_DISCOVER: 'cross_repo_auto_discover',
  CROSS_REPO_RETRY_ON_ACTIVE: 'cross_repo_retry_on_active',
  PR_KNOWLEDGE_STATUS: 'pr_knowledge_status',
  SELF_SERVE: 'self_serve',
  SELF_SERVE_CHANGE_PLAN_ENABLED: 'is_self_serve_change_plan_enabled',
  SELF_SERVE_DOWNGRADE_ENABLED: 'is_self_serve_downgrade_enabled',
  SELF_SERVE_UPGRADE_ENABLED: 'is_self_serve_upgrade_enabled',
  PR_SUMMARY_COMMENT_LOCATION: 'pr_summary_comment_location',
  SMART_ROUTER: 'smart_router',
  SMART_ROUTER_DEEP_MODE: 'smart_router_deep_mode',
  GITLAB_WIZARD_V2: 'gitlab_wizard_v2',
  BACKGROUND_TASKS_WIDGET: 'background_tasks_widget',
  SANDBOX_CONFIG: 'sandbox_config',
  WEB_SEARCH: 'web_search',
  CONFIGURATION_LAYOUT_V2: 'configuration_layout_v2',
} as const;
